import type { TemporaryAttachmentItem } from '@/components/common/TemporaryAttachmentPicker';

export function hasAttachmentErrors(items: TemporaryAttachmentItem[]): boolean {
  return items.some((item) => Boolean(item.error));
}
